import * as React from "react";

const Grid: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="27" height="19">
            <path
                fill="currentColor"
                d="M22.5 19L27 19L27 0L22.5 0L22.5 19ZM15 19L19.5 19L19.5 0L15 0L15 19ZM7.5 19L12 19L12 0L7.5 0L7.5 19ZM0 19L4.5 19L4.5 0L0 0L0 19Z"
                fillRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(Grid);
